import {
    TActionType,
    TransactionType,
} from '../../../Utility/Tracking/DataSet/Transaction';
import { gameTracking } from '../../../Utility/Tracking/FBLegacyTracking';
import { FBTrackingEvent } from '../../../Utility/Tracking/FBTrackingEvent';
import { trackTransaction } from '../../../Utility/Tracking/TrackingHelpers/Transaction';
import { IGameState } from '../../Game/IGameState';
import { showPopup, noCoinsPopupID } from '../../UI/UIStateHelper';
import { setLives, spendCoins } from '../PlayerInventoryHelper';

export function purchaseLife(state: IGameState) {
    if (state.playerState.coins >= 200) {
        let playerState = spendCoins(state.playerState, 200);
        playerState = setLives(playerState, state.playerState.lives + 1);

        state = {
            ...state,
            playerState,
            UIState: showPopup(state.UIState, 'receiveLivesMenu', {
                lives: 1,
            }),
        };

        gameTracking(FBTrackingEvent.BuyLifeCoins);

        trackTransaction(
            state,
            TransactionType.COIN_PURCHASE,
            TActionType.INVENTORY_PURCHASE
        );

        return state;
    }

    return {
        ...state,
        UIState: showPopup(state.UIState, noCoinsPopupID(), {}),
    };
}
